import StyledTab from './StyledTab';

export default StyledTab;